<script setup lang="ts">
defineProps({
    text: {
        type: String,
        required: true
    }
})
const emits = defineEmits(['showAlertPopup'])

const displayLearnMoreButton = ref(true)
const alertText = useTemplateRef('alertText')

onMounted(() => {
    if (alertText.value) {
        displayLearnMoreButton.value =
            alertText.value.clientHeight !== alertText.value.scrollHeight
    }
})
</script>

<template>
    <div
        class="w-full text-thirteen-exploitation tracking-light leading-4 bg-[#EF4444] text-white flex justify-between items-center p-4"
    >
        <div class="flex gap-2 items-center">
            <IconExclamationTriangle class="text-white size-5" is-solid />
            <p ref="alertText" class="font-normal line-clamp-1">
                {{ text }}
            </p>
        </div>
        <p
            v-if="displayLearnMoreButton"
            class="font-bold text-[#FEE2E2] cursor-pointer ml-3"
            @click="emits('showAlertPopup')"
        >
            {{ $t('word.more') }}
        </p>
    </div>
</template>
